import VatMessage from './VatMessage';

export default VatMessage;
